/**
 * Converts a date string (YYYY-MM-DD) or Date object to ISO 8601 datetime string
 * @param date {string|Date} - Date in YYYY-MM-DD format or Date object
 * @return {string} ISO 8601 datetime string (e.g., "2026-02-11T00:00:00Z")
 */
const dateToISO = (date) => {
    if (!date) return '';

    // If it's already a Date object
    if (date instanceof Date) {
        return date.toISOString();
    }

    // If it's a string in YYYY-MM-DD format
    if (typeof date === 'string') {
        // Check if it already has time component
        if (date.includes('T')) {
            // Already has time, just ensure it has Z suffix
            return date.endsWith('Z') ? date : `${date}Z`;
        }

        // Add time component and Z suffix for UTC
        return `${date}T00:00:00Z`;
    }

    return '';
};

export default dateToISO;
